function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "npmlogo_svg__cls-1",
  fill: "#CC3534",
  d: "M2 38.5h124v43.71H64v7.29H36.44v-7.29H2zm6.89 36.43h13.78V53.07h6.89v21.86h6.89V45.79H8.89zm34.44-29.14v36.42h13.78v-7.28h13.78V45.79zm13.78 7.29H64v14.56h-6.89zm20.67-7.29v29.14h13.78V53.07h6.89v21.86h6.89V53.07h6.89v21.86h6.89V45.79z"
});

function SvgNpmlogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    width: 56
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgd2lkdGg9IjU2cHgiPgoJPHBhdGggaWQ9Im9yaWdpbmFsLXdvcmRtYXJrIiBjbGFzcz0iY2xzLTEiIGZpbGw9IiNDQzM1MzQiIGQ9Ik0yLDM4LjVIMTI2VjgyLjIxSDY0Vjg5LjVIMzYuNDRWODIuMjFIMlpNOC44OSw3NC45M0gyMi42N1Y1My4wN2g2Ljg5Vjc0LjkzaDYuODlWNDUuNzlIOC44OVpNNDMuMzMsNDUuNzlWODIuMjFINTcuMTFWNzQuOTNINzAuODlWNDUuNzlabTEzLjc4LDcuMjlINjRWNjcuNjRINTcuMTFabTIwLjY3LTcuMjlWNzQuOTNIOTEuNTZWNTMuMDdoNi44OVY3NC45M2g2Ljg5VjUzLjA3aDYuODlWNzQuOTNoNi44OVY0NS43OVoiPgoJPC9wYXRoPgo8L3N2Zz4K";
export { SvgNpmlogo as ReactComponent };